// /* eslint-disable yoda */
// /* eslint-disable space-in-parens */
// /* eslint-disable indent */


const toggleNav = document.querySelector('.menu-toggle');
const toggleNavClose = document.querySelector('.mobile-nav-close');
const mainNav = document.querySelector('.main-navigation');
const navLinks = document.querySelectorAll('.main-navigation a');
console.log(navLinks);


toggleNav.addEventListener('click', () => {
	toggleNavClose.classList.add('is-active');
	mainNav.classList.add('nav-open');
});
toggleNavClose.addEventListener('click', () => {
	toggleNavClose.classList.toggle('is-active');
	mainNav.classList.toggle('nav-open');
});



document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
		if (toggleNavClose.classList.contains('is-active')) {
			toggleNavClose.classList.remove('is-active');
		}
		if (mainNav.classList.contains('nav-open')) {
			mainNav.classList.remove('nav-open');
		}
		
    });
});